import { QSScholarship, QSSkillPassport, QSAttendance, QSCareerPlacement } from "../assets/index.jsx";
import { getPortalSelectionAppUrl, ISUAT } from "../services";

export const featureSelectionConfig = (t, isSkipTranslation = false) => [
  {
    key: "scholarship",
    title: isSkipTranslation ? "Scholarship" : (t ? t("portal_selection.scholarship", "Scholarship") : "Scholarship"),
    subtitle: isSkipTranslation ? "Scholarship" : (t ? t("portal_selection.scholarship_desc", "Apply & Track") : "Apply & Track"),
    config: {
      img: QSScholarship,
      icon: "material-symbols:school",
    },
    path: getPortalSelectionAppUrl('scholarship', ''),
    enabled: true,
    comingSoon: true,
    color: "#7c3aed",
    bg: "rgba(124, 58, 237, 0.10)",
  },
  {
    key: "skillPassport",
    title: isSkipTranslation ? "Skill Passport" : (t ? t("portal_selection.skill_passport", "Skill Passport") : "Skill Passport"),
    subtitle: isSkipTranslation ? "Skill Passport" : (t ? t("portal_selection.skill_passport_desc", "Manage Skills") : "Manage Skills"),
    config: {
      img: QSSkillPassport,
      icon: "solar:chart-2-bold",
    },
    path: getPortalSelectionAppUrl('skillPassport', ''),
    enabled: true,
    color: "#ea580c",
    bg: "rgba(234, 88, 12, 0.10)",
  },
  {
    key: "attendance",
    title: isSkipTranslation ? "Attendance" : (t ? t("portal_selection.attendance", "Attendance") : "Attendance"),
    subtitle: isSkipTranslation ? "Attendance" : (t ? t("portal_selection.attendance_desc", "View Attendance") : "View Attendance"),
    config: {
      img: QSAttendance,
      icon: "material-symbols:grid-view",
    },
    path: getPortalSelectionAppUrl('attendance', ''),
    enabled: true,
    color: "#16a34a",
    bg: "rgba(22, 163, 74, 0.10)",
  },
  {
    key: "internshipAndPlacement",
    title: isSkipTranslation ? "Internship & Placement" : (t ? t("portal_selection.internship_and_placement", "Internship & Placement") : "Internship & Placement"),
    subtitle: isSkipTranslation ? "Internship & Placement" : (t ? t("portal_selection.internship_and_placement_desc", "Opportunities") : "Opportunities"),
    config: {
      img: QSCareerPlacement,
      icon: "solar:case-round-minimalistic-bold",
    },
    path: getPortalSelectionAppUrl('placementManagement', '/job-opportunities'),
    enabled: true,
    comingSoon: ISUAT ? true : false,
    color: "#2563eb",
    bg: "rgba(37, 99, 235, 0.10)",
  },
];

export default featureSelectionConfig;
